import { useState } from "react";
import { PlayCircle } from "lucide-react";
import { API } from "@/lib/api";

function youtubeId(url) {
  const m = (url || "").match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? m[1] : null;
}

export function hasVideo(config) {
  return !!config?.video_ativo && (!!youtubeId(config.video_url) || !!config.tem_video);
}

export default function VideoSection({ config }) {
  const [playing, setPlaying] = useState(false);
  if (!hasVideo(config)) return null;
  const yt = youtubeId(config.video_url);

  return (
    <div data-testid="video-section" className="w-full max-w-md lg:max-w-none mx-auto lg:mx-0 fade-up" style={{ animationDelay: "200ms" }}>
      <div className="bg-white/10 backdrop-blur-md border border-white/15 rounded-3xl p-2.5 shadow-[0_24px_60px_-24px_rgba(0,0,0,0.6)]">
        <div className="relative aspect-video rounded-2xl overflow-hidden bg-black">
          {yt ? (
            <iframe
              data-testid="video-youtube"
              className="absolute inset-0 w-full h-full"
              src={`https://www.youtube-nocookie.com/embed/${yt}?rel=0`}
              title={config.video_titulo || "Vídeo"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video
              data-testid="video-player"
              className="absolute inset-0 w-full h-full"
              src={`${API}/video?v=${encodeURIComponent(config.updated_at || "")}`}
              controls
              playsInline
              preload="metadata"
              onPlay={() => setPlaying(true)}
            />
          )}
          {!yt && !playing && (
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
              <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-xl">
                <PlayCircle className="w-10 h-10 text-[#0f2a6b]" />
              </div>
            </div>
          )}
        </div>
        {config.video_titulo && (
          <p data-testid="video-title" className="font-heading px-2 pt-2.5 pb-1 text-sm sm:text-base font-bold text-white inline-flex items-center gap-2">
            <PlayCircle className="w-4 h-4 text-blue-200" /> {config.video_titulo}
          </p>
        )}
      </div>
    </div>
  );
}
